
import { createContext } from 'react';

export type CustomError = {
    timeout?: number;
    message: string;
}

export interface IErrorContext {
    errors: CustomError[];
    addError: (error: CustomError) => void;
    removeError: (error: CustomError) => void;
}

const ErrorContext = createContext<IErrorContext>({
    errors: [],
    addError: (error: CustomError) => {},
    removeError: (error: CustomError) => {}
});

export default ErrorContext;